import {
  passengerBuilder,
  PassengerModel
} from 'app/client/clientBusiness/Passenger/models/Passenger';
import { ClientType } from 'app/client/main/models/ClientType';
import {
  domicilioBuilder,
  DomicilioModel
} from 'app/domicilio/models/DomicilioModel';
import {
  BusRequirement,
  ViajeCanalesDeIngreso,
  ViajeTrasladoEstado
} from 'app/viaje/models';
import moment, { Moment } from 'moment';
import { TransferReservationPrices } from './TransferReservationPrices';
import { ViajeTrasladoTipoServicio } from './ViajeTrasladoTipoServicio';

export interface ViajeTrasladosGestionEstado {
  datetime: string;
  observation: string;
  type: string;
  user: {
    email: string;
    id: number;
    isDeleted: boolean;
    name: string;
  };
}

export interface ItemAirport {
  item_id: number;
  quantity: number;
  name: string;
  description: string;
}

export interface AirportDetails {
  number_flight: number | null;
  name_aeroline: number | null;
  items: ItemAirport[] | null;
}

export enum TypePaymentStatus {
  CREATED = 'Creado',
  PENDING = 'Pendiente de confirmación',
  APPROVED = 'Aprobado',
  REJECTED = 'Rechazado',
  CANCELLED = 'Cancelado',
  PAID = 'Pagado'
}

export interface PaymentStatus {
  datetime: Moment
  id: number
  status_detail: string;
  status_id: number;
  status_name: TypePaymentStatus;
  status_description: string;
}

export interface Payment {
  id: number;
  transfer_reservation_id: number;
  amount: number | null;
  payment_method: string;
  card_id: string;
  created_at: string;
  expiration_month: number;
  expiration_year: number;
  idempotency_key: string | null;
  issuer_name: string;
  last_four_digits: string;
  paid_at: string | null;
  payment_gateway_id: number | null;
  states: PaymentStatus[];
  token: string;
  updated_at: string;
}

export enum TransferReservationType {
  CORPORATIVE = 'Corporativo',
  PARTICULAR_CORPORATIVE = 'Particular Corporativo',
  PARTICULAR = 'Particular'
}

export interface TransferReservationPartialModel {
  id: number;
  client: {
    id: number;
    name: string;
    hasPriority: boolean;
    type: string;
    company_name: string;
  };
  platformId: number;
  hasPriority: false;
  serviceType: ViajeTrasladoTipoServicio;
  coordinationObservation: string;
  general_observation?: string | null;
  reservationDatetime: Moment;
  departureDatetime: Moment;
  advanceHours: number;
  arrivalDateTime: Moment;
  state: ViajeTrasladoEstado;
  show_waiting_clock: boolean;
  total_minutes_waiting: number;
  clientType: ClientType;
  contretemps: string;
  setback_comments: string | null;
  is_arrive_ok: boolean;
  deviation_observation: string | null;
  entryChannel: ViajeCanalesDeIngreso;
  locations: {
    observation: string;
    minutesWaiting: number;
    address: DomicilioModel;
    passengers: PassengerModel[];
  }[];
  state_datetime: Moment;
  estimated_prices: TransferReservationPrices | null;
  calculated_prices: TransferReservationPrices | null;
  final_prices: TransferReservationPrices | null;
  pay_with_cash: boolean;
  is_event: boolean;
  event_name?: string;
  states?: ViajeTrasladosGestionEstado[];
  cancel_observation?: string;
  lltpais?: any;
  bus_requirement?: BusRequirement | null;
  pre_assigned_driver?: any;
  airport_details: AirportDetails | null;
  observation_transfer_reservations_app?: string | null;
  service_type?: string;
  validation_reason: string | null;
  reason_reserve_past?: string | null;
  type: TransferReservationType;
}

export const transferReservationPartialBuilder = {
  fromBackEnd: (reservation): TransferReservationPartialModel => ({
    ...reservation,
    reservationDatetime: moment(reservation.reservationDatetime),
    arrivalDateTime: moment(reservation.arrivalDatetime ?? reservation.arrivalDateTime),
    departureDatetime: moment(reservation.departureDateTime),
    contretemps: reservation.setback,
    setback_comments: reservation.setback_comments ?? null,
    is_arrive_ok: reservation.is_arrive_ok ?? false,
    show_waiting_clock: reservation.show_waiting_clock ?? false,
    total_minutes_waiting: reservation.total_minutes_waiting ?? 0,
    locations: reservation.locations.map((location) => ({
      ...location,
      address: domicilioBuilder.fromBackEnd(location.address),
      passengers: location.passengers.map(passengerBuilder.fromBackEnd)
    })),
    state_datetime: moment(reservation.state_datetime)
  })
};
